import { SupervisionTimeCalculationsInvalidator } from "@/composables/useSupervisionTimeCalculations";
import type { QueryClient } from "@tanstack/vue-query";

/**
 * Initialize query invalidation utilities with the QueryClient instance.
 * This should be called once during app initialization.
 */
export function initializeQueryInvalidation(queryClient: QueryClient) {
  SupervisionTimeCalculationsInvalidator.setQueryClient(queryClient);
}

/**
 * Utility functions to call after mutations that affect supervision time calculations.
 * These should be integrated into your existing mutation handlers.
 */
export const invalidateSupervisionCalculations = {
  /**
   * Call after any mutation that affects supervision time calculations
   * Example: Absence, Duty, Event, Employment
   * @param employmentIds - The employment IDs that were affected by the mutation
   */
  afterSupervisionTimeCalculationsMutation: async (employmentIds: number[]) => {
    await SupervisionTimeCalculationsInvalidator.onSupervisionTimeCalculationsChanged(
      employmentIds
    );
  }
};
